import { render, staticRenderFns } from "./EthnicitiesMove.vue?vue&type=template&id=5d171240&"
import script from "./EthnicitiesMove.vue?vue&type=script&lang=js&"
export * from "./EthnicitiesMove.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports